const SearchResultMediaType = 'application/vnd.sas.metadata.search.result';
const SearchResultCollectionMediaType = 'application/vnd.sas.metadata.search.collection';
const SearchFacetMediaType = 'application/vnd.sas.metadata.definition.search.facet';
export const SearchResultBaseJSON = `${SearchResultMediaType}+json`;
export const SearchResultCollectionJSON = `${SearchResultCollectionMediaType}+json`;
export const SearchFacetsBaseJSON = `${SearchFacetMediaType}+json`;
//# sourceMappingURL=representations.js.map